import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { ArrowRight, ChevronLeft, ChevronRight } from 'lucide-react';

const CheckoutSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slideImages = [
    {
      url: 'https://customer-assets.emergentagent.com/job_adanos-menu-sync/artifacts/fk0f06ft_Adanos%20Burger.jpg',
      alt: 'Adanos Burger with cheese bites'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_adanos-menu-sync/artifacts/husvlssj_Half%20Chicken.jpeg',
      alt: 'Half Chicken with rice and fries'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_adanos-menu-sync/artifacts/2rdil445_Meat%20Stack.jpg',
      alt: 'Meat Stack burger'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slideImages.length);
    }, 4000);
    return () => clearInterval(timer);
  }, [slideImages.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slideImages.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slideImages.length) % slideImages.length);
  };

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="bg-gradient-to-br from-red-50 to-white rounded-2xl shadow-xl overflow-hidden border-2 border-red-100">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
            {/* Text Content */}
            <div className="p-12 lg:p-16 flex flex-col justify-center">
              <h2 className="text-4xl lg:text-5xl font-black text-gray-900 mb-6">
                Adanos Special Burger
              </h2>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                Experience Oldham's best smashburgers with our signature special recipe. 
                Each burger is crafted with premium halal ingredients, hand-smashed to perfection, 
                and served with love. From classic cheeseburgers to our famous triple patty monster, 
                there's something for everyone.
              </p>
              <div className="space-y-4">
                <p className="text-gray-700 font-semibold flex items-center">
                  <span className="bg-red-600 text-white w-6 h-6 rounded-full flex items-center justify-center mr-3 text-sm">✓</span>
                  Premium 100% beef patties
                </p>
                <p className="text-gray-700 font-semibold flex items-center">
                  <span className="bg-red-600 text-white w-6 h-6 rounded-full flex items-center justify-center mr-3 text-sm">✓</span>
                  Fresh ingredients daily
                </p>
                <p className="text-gray-700 font-semibold flex items-center">
                  <span className="bg-red-600 text-white w-6 h-6 rounded-full flex items-center justify-center mr-3 text-sm">✓</span>
                  Halal-certified options
                </p>
              </div>
              <div className="mt-8">
                <Link to="/menu">
                  <Button
                    size="lg"
                    className="bg-red-600 hover:bg-red-700 text-white font-bold px-8 py-6 rounded-full transition-all hover:scale-105"
                  >
                    VIEW FULL MENU
                    <ArrowRight className="ml-2 h-5 w-5" />
                  </Button>
                </Link>
              </div>
            </div>

            {/* Image Slideshow */}
            <div className="relative h-[400px] lg:h-[500px] overflow-hidden group">
              {slideImages.map((image, index) => (
                <div
                  key={index}
                  className={`absolute inset-0 transition-opacity duration-700 ease-in-out ${
                    index === currentSlide ? 'opacity-100' : 'opacity-0'
                  }`}
                >
                  <img
                    src={image.url}
                    alt={image.alt}
                    className="w-full h-full object-cover"
                  />
                </div>
              ))}
              
              {/* Navigation Arrows */}
              <button
                onClick={prevSlide}
                className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white p-2 rounded-full shadow-lg opacity-0 group-hover:opacity-100 transition-opacity"
              >
                <ChevronLeft className="h-6 w-6 text-gray-800" />
              </button>
              <button
                onClick={nextSlide}
                className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white p-2 rounded-full shadow-lg opacity-0 group-hover:opacity-100 transition-opacity"
              >
                <ChevronRight className="h-6 w-6 text-gray-800" />
              </button>

              {/* Dots Indicator */}
              <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex space-x-2">
                {slideImages.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentSlide(index)}
                    className={`w-3 h-3 rounded-full transition-all ${
                      index === currentSlide ? 'bg-red-600 w-6' : 'bg-white/70'
                    }`}
                  />
                ))}
              </div>

              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CheckoutSection;
